import { render, staticRenderFns } from "./BagNumberList.vue?vue&type=template&id=948f5c4e&scoped=true"
import script from "./BagNumberList.vue?vue&type=script&lang=js"
export * from "./BagNumberList.vue?vue&type=script&lang=js"
import style0 from "./BagNumberList.vue?vue&type=style&index=0&id=948f5c4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948f5c4e",
  null
  
)

export default component.exports